import { combineReducers } from 'redux';
import searchResultReducer from './search-result';
import formManagerReducer from './form-manager';

const settingsAutoCommunicationReducer = combineReducers({
  searchResult: searchResultReducer,
  formManager: formManagerReducer,
});

export default settingsAutoCommunicationReducer;
